import { ReactElement } from "react";

import { Login } from "_/components/login";
import { Logo } from "_/components/logo";

import * as S from "./styled";

export const LoginView = (): ReactElement => (
  <S.Wrapper>
    <S.Card>
      <S.Brand>
        <Logo style={{ width: 140 }} />
      </S.Brand>
      <Login />
    </S.Card>
  </S.Wrapper>
);
